import cx from "clsx";
import Image from "next/image";
import React from "react";

import svgBg from "./assets/bg.svg";
import svgFg from "./assets/fg.svg";
import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function FigureWaiting$TxBreakdown({ className, style }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Image className={styles.bg} src={svgBg} alt="" fill sizes="112px" />
      <Image className={styles.fg} src={svgFg} alt="" fill sizes="112px" />
    </div>
  );
}
